module.exports = __webpack_public_path__ + "img/160.e870e87e.jpg";